import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageDropdown = () => {
  const { currentLanguage, changeLanguage, getCurrentLanguage, getAllLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = getCurrentLanguage();
  const languages = getAllLanguages();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  const styles = {
    dropdownContainer: {
      position: 'relative',
      display: 'inline-block',
    },
    dropdownButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '1px', // ปรับให้เท่ากับ navLink
      backgroundColor: 'rgba(3, 155, 229, 0.05)',
      border: '1px solid transparent', // ปรับให้เท่ากับ navLink
      borderRadius: '50px', // เพิ่มความโค้งให้เป็นรูปไข่เหมือนในภาพ
      padding: '0.27rem 0.54rem', // ปรับให้เท่ากับ navLink
      color: '#333',
      cursor: 'pointer',
      fontSize: '0.8rem', // ลดลงจาก 0.936rem
      fontWeight: 'normal', // เปลี่ยนจาก '500' เป็น 'normal'
      transition: 'all 0.3s ease',
      minWidth: '120px', // ปรับให้เท่ากับ navLink
      minHeight: '21px', // ปรับให้เท่ากับ navLink
      justifyContent: 'center', // จัดให้เนื้อหาอยู่ตรงกลาง
      whiteSpace: 'nowrap', // ป้องกันการขึ้นบรรทัดใหม่
    },
    dropdownButtonHover: {
      backgroundColor: 'rgba(3, 155, 229, 0.1)',
      borderColor: 'rgba(3, 155, 229, 0.3)',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(3, 155, 229, 0.15)',
    },
    dropdownMenu: {
      position: 'absolute',
      top: 'calc(100% + 4px)', // ลดจาก 8px เป็น 4px
      right: '0',
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(3, 155, 229, 0.1)',
      borderRadius: '25px', // ปรับให้เหมาะสมกับปุ่มที่โค้งมากขึ้น
      boxShadow: '0 8px 32px rgba(3, 155, 229, 0.15)',
      minWidth: '120px', // ปรับให้เท่ากับปุ่ม
      zIndex: 1000,
      opacity: isOpen ? 1 : 0,
      visibility: isOpen ? 'visible' : 'hidden',
      transform: isOpen ? 'translateY(0)' : 'translateY(-10px)',
      transition: 'all 0.3s ease',
    },
    dropdownItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px', // ลดจาก 10px เป็น 6px
      padding: '0.27rem 0.54rem', // ปรับให้เท่ากับปุ่ม
      cursor: 'pointer',
      fontSize: '0.8rem', // ลดลงจาก 0.936rem
      color: '#333',
      fontWeight: 'normal', // เปลี่ยนจาก '500' เป็น 'normal'
      borderBottom: '1px solid rgba(3, 155, 229, 0.05)',
      transition: 'all 0.2s ease',
      minHeight: '21px', // ปรับให้เท่ากับปุ่ม
      justifyContent: 'center', // จัดให้เนื้อหาอยู่ตรงกลาง
      borderRadius: '25px', // ปรับให้เหมาะสมกับปุ่มที่โค้งมากขึ้น
    },
    dropdownItemHover: {
      backgroundColor: 'rgba(3, 155, 229, 0.08)',
      color: '#039be5',
    },
    dropdownItemActive: {
      backgroundColor: 'rgba(3, 155, 229, 0.12)',
      color: '#039be5',
      fontWeight: '600',
    },
    dropdownItemLast: {
      borderBottom: 'none',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
    },
    flag: {
      fontSize: '0.6rem', // ลดจาก 1rem เป็น 0.6rem
    },
    languageName: {
      flex: 1,
    },
    checkmark: {
      color: '#039be5',
      fontSize: '0.5rem', // ลดจาก 0.8rem เป็น 0.5rem
      fontWeight: 'bold',
    },
    chevron: {
      fontSize: '0.4rem', // ลดจาก 0.6rem เป็น 0.4rem
      transition: 'transform 0.2s ease',
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    }
  };

  return (
    <div style={styles.dropdownContainer} ref={dropdownRef}>
      <button
        style={{
          ...styles.dropdownButton,
          ...(isOpen && styles.dropdownButtonHover)
        }}
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'rgba(3, 155, 229, 0.1)';
          e.target.style.borderColor = 'rgba(3, 155, 229, 0.3)';
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 12px rgba(3, 155, 229, 0.15)';
        }}
        onMouseLeave={(e) => {
          if (!isOpen) {
            e.target.style.backgroundColor = 'rgba(3, 155, 229, 0.05)';
            e.target.style.borderColor = 'transparent'; // ปรับให้เท่ากับ navLink
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }
        }}
      >
        <span style={styles.currentFlag}>{currentLang.flag}</span>
        <span style={styles.currentLanguage}>{currentLang.name}</span>
        <span style={styles.chevron}>▼</span>
      </button>

      <div style={styles.dropdownMenu}>
        {languages.map((language, index) => (
          <div
            key={language.code}
            style={{
              ...styles.dropdownItem,
              ...(index === languages.length - 1 && styles.dropdownItemLast),
              ...(language.code === currentLanguage && styles.dropdownItemActive)
            }}
            onClick={() => handleLanguageChange(language.code)}
            onMouseEnter={(e) => {
              if (language.code !== currentLanguage) {
                e.target.style.backgroundColor = 'rgba(3, 155, 229, 0.08)';
                e.target.style.color = '#039be5';
              }
            }}
            onMouseLeave={(e) => {
              if (language.code !== currentLanguage) {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#333';
              }
            }}
          >
            <span style={styles.flag}>{language.flag}</span>
            <span style={styles.languageName}>{language.name}</span>
            {language.code === currentLanguage && (
              <span style={styles.checkmark}>✓</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageDropdown; 